/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import { AuthenticationAuditPageOutput, CustomerManagementEventPageOutput } from '../model';
import type { AuthenticationEventsParams, ListCustomerManagementEventsParams } from '../model';

import { validatedFetch } from '../../client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAuthenticationEventsUrl = (params?: AuthenticationEventsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/access/authentication-events?${stringifiedParams}`
    : `/api/v1/access/authentication-events`;
};

export const authenticationEvents = async (
  params?: AuthenticationEventsParams,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<AuthenticationAuditPageOutput> => {
  return validatedFetch<AuthenticationAuditPageOutput>(getAuthenticationEventsUrl(params), {
    ...options,
    method: 'GET',

    schema: AuthenticationAuditPageOutput,
  });
};

export const getAuthenticationEventsQueryKey = (params?: AuthenticationEventsParams) => {
  return [`/api/v1/access/authentication-events`, ...(params ? [params] : [])] as const;
};

export const getAuthenticationEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof authenticationEvents>>,
  TError = unknown,
>(
  params?: AuthenticationEventsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof authenticationEvents>>, TError, TData>;
    request?: SecondParameter<typeof validatedFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthenticationEventsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authenticationEvents>>> = ({ signal }) =>
    authenticationEvents(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authenticationEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AuthenticationEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof authenticationEvents>>
>;
export type AuthenticationEventsQueryError = unknown;

export function useAuthenticationEvents<
  TData = Awaited<ReturnType<typeof authenticationEvents>>,
  TError = unknown,
>(
  params?: AuthenticationEventsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof authenticationEvents>>, TError, TData>;
    request?: SecondParameter<typeof validatedFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAuthenticationEventsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getListCustomerManagementEventsUrl = (params?: ListCustomerManagementEventsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/customer-management-events?${stringifiedParams}`
    : `/api/v1/customer-management-events`;
};

export const listCustomerManagementEvents = async (
  params?: ListCustomerManagementEventsParams,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<CustomerManagementEventPageOutput> => {
  return validatedFetch<CustomerManagementEventPageOutput>(
    getListCustomerManagementEventsUrl(params),
    {
      ...options,
      method: 'GET',

      schema: CustomerManagementEventPageOutput,
    },
  );
};

export const getListCustomerManagementEventsQueryKey = (
  params?: ListCustomerManagementEventsParams,
) => {
  return [`/api/v1/customer-management-events`, ...(params ? [params] : [])] as const;
};

export const getListCustomerManagementEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCustomerManagementEvents>>,
  TError = unknown,
>(
  params?: ListCustomerManagementEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCustomerManagementEvents>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof validatedFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCustomerManagementEventsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomerManagementEvents>>> = ({
    signal,
  }) => listCustomerManagementEvents(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCustomerManagementEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCustomerManagementEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCustomerManagementEvents>>
>;
export type ListCustomerManagementEventsQueryError = unknown;

export function useListCustomerManagementEvents<
  TData = Awaited<ReturnType<typeof listCustomerManagementEvents>>,
  TError = unknown,
>(
  params?: ListCustomerManagementEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCustomerManagementEvents>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof validatedFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCustomerManagementEventsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}
